"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVanityCodeAndLeadId = exports.isEAPOnDeviceSuccessfulOrder = exports.isConnectedCarFlow = exports.getOrdertype = exports.getTradePortIn = exports.getPlanDetails = exports.getInsuranceList = exports.getSKUsFromTheCart = exports.getPersonalizationParams = exports.getAdditionalParams = exports.contrsuctOrderConfirmURL = void 0;
var commonUtils = require("./UtilityFunctions");
var cartUtils = require("./CartUtilFunctions");
var numUtil = require("./NumberSelectionUtil");
function contrsuctOrderConfirmURL(orderInfo) {
    var _a, _b, _c, _d, _e, _f, _g;
    var isPurchaseOrderRedirection = commonUtils.purchaseorderThankyouRedirection();
    var finalURL = '';
    var CryptoJS = require('crypto-js');
    if ((_a = orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.orderInfo) === null || _a === void 0 ? void 0 : _a.customerOrderNumber) {
        finalURL = finalURL + ("&orderNum=" + orderInfo.orderInfo.customerOrderNumber);
    }
    if ((_d = (_c = (_b = orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.orderInfo) === null || _b === void 0 ? void 0 : _b.contactDetail) === null || _c === void 0 ? void 0 : _c.personalDetail) === null || _d === void 0 ? void 0 : _d.firstName) {
        finalURL = finalURL + ("&name=" + CryptoJS.AES.encrypt(orderInfo.orderInfo.contactDetail.personalDetail.firstName, 'checkout-ui-app-2022').toString());
    }
    if ((_g = (_f = (_e = orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.orderInfo) === null || _e === void 0 ? void 0 : _e.contactDetail) === null || _f === void 0 ? void 0 : _f.personalDetail) === null || _g === void 0 ? void 0 : _g.emailAddress) {
        finalURL = finalURL + ("&pid=" + CryptoJS.AES.encrypt(orderInfo.orderInfo.contactDetail.personalDetail.emailAddress, 'checkout-ui-app-2022').toString());
    }
    finalURL = finalURL + ("&flowType=" + commonUtils.getCurrentFlowType());
    if (isEAPOnDeviceSuccessfulOrder(orderInfo)) {
        finalURL = finalURL + "&subType=EAPOnDeviceSuccessfulOrder";
    }
    if (orderInfo && orderInfo.poeDetails &&
        'TEACHER|HEALTHCARE'.indexOf(orderInfo.poeDetails.customerContractSubType) > -1) {
        finalURL = finalURL + ("&subType=" + orderInfo.poeDetails.customerContractSubType);
    }
    var resultUrl = "?" + (getAdditionalParams() + getPersonalizationParams() + finalURL) + ";";
    finalURL = isPurchaseOrderRedirection ? resultUrl : "/" + resultUrl;
    return { finalURL: finalURL };
}
exports.contrsuctOrderConfirmURL = contrsuctOrderConfirmURL;
function getAdditionalParams() {
    if (commonUtils.getCurrentFlowType() && commonUtils.getCurrentFlowType()
        .search("NEW_WIRELESS_ON_ACTIVATION|AAL_WIRELESS_ON_ACTIVATION|\n        AAL_WIRELESS_ON_ACTIVATION_NEW_HBOMAX|NEW_WIRELESS_ON_ACTIVATION_NEW_HBOMAX") > -1) {
        return 'options=skipGN,skipMRKT,skipDWApp&';
    }
    else if (!commonUtils.IsWirelessInCart()) {
        return 'options=skipMRKT&';
    }
    return '';
}
exports.getAdditionalParams = getAdditionalParams;
function getPersonalizationParams() {
    return getSKUsFromTheCart() + getInsuranceList() +
        getPlanDetails() + getTradePortIn() + getOrdertype() + isConnectedCarFlow();
}
exports.getPersonalizationParams = getPersonalizationParams;
function getSKUsFromTheCart() {
    return '&dev_skus=' + cartUtils.getItemsListFromCart();
}
exports.getSKUsFromTheCart = getSKUsFromTheCart;
function getInsuranceList() {
    return '&dev_ins=' + cartUtils.getInsuranceListFromCart();
}
exports.getInsuranceList = getInsuranceList;
function getPlanDetails() {
    return "&dev_plan=" + cartUtils.getPlanListFromCart();
}
exports.getPlanDetails = getPlanDetails;
function getTradePortIn() {
    return "&dev_port=" + (numUtil.isNumberPortIn() ? 'Yes' : 'No');
}
exports.getTradePortIn = getTradePortIn;
function getOrdertype() {
    return "&orderType=" + commonUtils.getCurrentFlowType();
}
exports.getOrdertype = getOrdertype;
function isConnectedCarFlow() {
    return "&isConnectedCarFlow=" + commonUtils.isConnectedCarFlow();
}
exports.isConnectedCarFlow = isConnectedCarFlow;
function isEAPOnDeviceSuccessfulOrder(data) {
    var eapFlowType = cartUtils.getEAPDetails().eapFlowType;
    return !!(eapFlowType && (eapFlowType === 'NEW_EAP_ON' || eapFlowType === 'AAL_EAP_ON') && data
        && data.wirelessCart && data.wirelessCart.losgs && Object.
        values(data.wirelessCart.losgs).filter(function (losg) { return losg.losgStatus
        && losg.losgStatus.status && losg.losgStatus.status === 'ACTIVATED'; })[0]);
}
exports.isEAPOnDeviceSuccessfulOrder = isEAPOnDeviceSuccessfulOrder;
function getVanityCodeAndLeadId() {
    var _a, _b;
    var obj = {};
    try {
        var parsedSession = sessionStorage.getItem('wtExtndSource') || '';
        var matched = parsedSession.replace(/^\//, '').match(/(^[0-9a-zA-Z]*)\/([0-9a-zA-Z]*$)/) || [];
        if (matched[1] && matched[2]) {
            obj["vanityCode"] = (_a = matched[1]) === null || _a === void 0 ? void 0 : _a.substring(0, 30);
            obj["leadId"] = (_b = matched[2]) === null || _b === void 0 ? void 0 : _b.substring(0, 30);
        }
    }
    catch (e) {
        console.error('Error parsing vanityCode and leadId from sessionStorage:', e);
    }
    return obj;
}
exports.getVanityCodeAndLeadId = getVanityCodeAndLeadId;
//# sourceMappingURL=OrderSubmitUtilFunctions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/utils/OrderSubmitUtilFunctions.js
// module id = 2086
// module chunks = 8